/**
 * Utility function to get favicon URL from a website URL.
 * Returns direct favicon.ico path - the img element uses referrerPolicy="no-referrer"
 * to avoid strict-origin-when-cross-origin / CORS issues.
 * @param {string} url - The website URL
 * @returns {string|null} - The favicon URL or null if invalid
 */
const getFaviconUrl = (url) => {
  if (!url) {
    return null;
  }

  try {
    const urlObj = new URL(url);
    if (
      (urlObj.protocol !== "https:" && urlObj.protocol !== "http:") ||
      !urlObj.hostname
    ) {
      return null;
    }
    return `https://${urlObj.hostname}/favicon.ico`;
  } catch (error) {
    return null;
  }
};

export default getFaviconUrl;
